import {
  IField,
  IList,
  IListColumn,
  IListElementCell,
  isInternalListCell,
} from 'app/services/api5-service/api.interface';

import { ISPFormState } from 'common/dynamic-form/model';
import { DocHelper } from 'utils/dochelper';

import { IListCellUi } from '../../list-cell/model';
import { IListRowUi, ListConfig } from '../../model';
import { filterEmptyColumns } from '../filter-empty-columns';
import { getListCell } from '../get-list-cell';
import { getInternalListCollapse } from '../get-list-collapse';
import { getListHeaderCells } from '../get-list-header-cells';
import { getInternalListTitle } from '../get-list-title';

/**
 * Get button cell with specific data
 *
 * @param control
 * @param field
 * @param cell - FE cell base metadata
 * @param column - BE meta of list column
 * @param state - form state
 * @param cellData - BE data of cell
 * @param config - list config
 */
export function getListCellWithData(
  control: IList,
  field: IField,
  cell: IListCellUi,
  column: IListColumn,
  state: ISPFormState,
  cellData: IListElementCell,
  config: ListConfig,
): IListCellUi {
  if (!isInternalListCell(cellData) || column.$type !== 'list') {
    return cell;
  }

  const internalListElements = DocHelper.getArrayWrapperValue(cellData.elem);
  const notEmptyColumns = filterEmptyColumns(column.col, internalListElements);
  cell.listData = {
    type: 'table',
    listName: column.$name,
    title: getInternalListTitle(column, state.docSubject.value),
    collapse: getInternalListCollapse(column, state.docSubject.value),
    hover: column.$hover !== 'no',
    underline: column.$underline === 'yes',
    items: internalListElements.map(internalElement => {
      const cells = notEmptyColumns
        .map(internalColumn =>
          getListCell(
            control,
            field,
            internalColumn,
            internalElement,
            state,
            config,
          ),
        )
        .flat();

      return {
        cells,
        part: 'full',
        preset:
          column.$row_type !== undefined &&
          ['small', 'medium', 'large'].includes(column.$row_type)
            ? column.$row_type
            : 'small',
      } as IListRowUi;
    }),
    displayLimit: Number(column.$display_limit),
  };

  const additionalHeader = DocHelper.getArrayWrapperValue(cellData.header);

  const headerCells = getListHeaderCells(
    state.docSubject.value,
    notEmptyColumns,
    additionalHeader,
  );

  cell.listData.header = headerCells
    ? {
        cells: headerCells,
      }
    : undefined;
  cell.verticalAlign = cell.verticalAlign || 'top';
  return cell;
}
